import React from "react";
import { Avatar, Chip, Grid, MenuItem, Typography } from "@mui/material";

interface DependentMenuItemsProps {
	items: {
		name: string;
		label: string;
		amount?: string;
	}[];
}

const DependentMenuItems: React.FC<DependentMenuItemsProps> = ({ items }) => {
	// console.log("items", items);
	return (
		<>
			{items.map((item, index) => (
				<MenuItem key={index}>
					<Grid container alignItems="center" spacing={1}>
						<Grid item>
							<Avatar sx={{ width: 24, height: 24 }}>{item.name[0]}</Avatar>
						</Grid>
						<Grid item xs>
							<Typography variant="body2" noWrap>
								{item.name}
							</Typography>
						</Grid>
						<Grid item>
							<Chip
								label={item.label}
								size="small"
								sx={{
									backgroundColor: "green",
									color: "white",
									marginRight: "10px",
									fontSize: "0.75rem",
									height: 20
								}}
							/>
						</Grid>
						<Grid item>
							<Typography variant="body2">{item.amount}</Typography>
						</Grid>
					</Grid>
				</MenuItem>
			))}
		</>
	);
};

export default DependentMenuItems;
